module.exports = __webpack_public_path__ + "media/le-reshop/femme-a220dfad.png";